<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-2/3 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color bg-wite">

          <div class="vx-row no-gutter justify-center items-center ">

            <div class="vx-col hidden lg:block lg:w-1/2 px-4 py-10 color-bg-login min-h-login ">
              <img class="mb-5 max-w-logo d-block m-auto" src="@/assets/images/logo/logo.svg" alt="registerImg">
              <img src="@/assets/images/pages/workspace.svg" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container py-login">

                <div class="vx-row vx-card__title mb-4">
                  <div class="vx-col md:w-full">
                    <h2 class="mb-4">¡Queremos conocerte!</h2>
                  </div>

                  <!-- ¿Cómo usarás DigitaFirma? -->
                  <div class="vx-col w-1/2">
                    <label class="text-sm label-vs d-block">¿Cómo usarás Verificamex?</label>
                    <v-select
                      v-model="selectUsoDigitaFirma"
                      :options="usoDigitaFirmaOptions"
                      :reduce="option => option.value"
                      class="select-large mt-3 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- ¿Cómo te identificas? -->
                  <div class="vx-col w-1/2">
                    <label class="text-sm label-vs d-block">¿Cómo te identificas?</label>
                    <v-select
                      v-model="selectTipoPersona"
                      :options="tipoPersonaOptions"
                      :reduce="option => option.value"
                      class="select-large mt-3 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- ¿Cuál es tu sector? -->
                  <div class="vx-col w-full">
                    <label class="text-sm label-vs d-block">¿Cuál es tu sector?</label>
                    <v-select
                      v-model="selectSector"
                      :options="sectorOptions"
                      class="questions-select mt-3 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- Tamaño de tu empresa -->
                  <div class="vx-col w-1/2">
                    <label class="text-sm label-vs d-block">Tamaño de tu empresa</label>
                    <v-select
                      v-model="selectCantidadEmpleados"
                      :options="cantidadEmpleadosOptions"
                      :reduce="option => option.value"
                      class="select-large mt-2 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- ¿Cómo quieres firmar? -->
                  <div class="vx-col w-1/2">
                    <label class="text-sm label-vs d-block">¿Cómo quieres firmar?</label>
                    <v-select
                      v-model="selectTipoFirma"
                      :options="tipoFirmaOptions"
                      :reduce="option => option.value"
                      class="select-large mt-2 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- ¿Cuánto firmas al mes? -->
                  <div class="vx-col w-1/2">
                    <label class="text-sm label-vs d-block">¿Cuánto firmas al mes?</label>
                    <v-select
                      v-model="selectCantidadFirmas"
                      :options="cantidadFirmasOptions"
                      :reduce="option => option.value"
                      class="select-large mt-2 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- ¿Cómo se enteró de nosotros? -->
                  <div class="vx-col w-1/2">
                    <label class="text-sm label-vs d-block">¿Cómo se enteró de nosotros?</label>
                    <v-select
                      v-model="selectComoSeEntero"
                      :options="comoSeEnteroOptions"
                      :reduce="option => option.value"
                      class="select-large mt-2 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- Botón Siguiente -->
                  <div class="vx-col mt-3">
                    <vs-button :disabled="isSubmitting" id="button-with-loading" class="float-right" @click="storeQuestions">Siguiente</vs-button>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import router from '@/router';

export default {
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      selectUsoDigitaFirma: '',
      usoDigitaFirmaOptions: [
        { value: 'api', label: 'Quiero firmar vía API' },
        { value: 'plataforma', label: 'Usaré la plataforma Web' },
      ],
      selectTipoPersona: '',
      tipoPersonaOptions: [
        { value: 'Persona física', label: 'Persona física' },
        { value: 'Persona Moral (Empresa)', label: 'Persona Moral (Empresa)' },
      ],
      selectSector: '',
      sectorOptions: [
        'Banca y finanzas',
        'Bienes raíces y construcción',
        'Consultoría y servicios profesionales',
        'Educación',
        'Energía y recursos naturales',
        'Farmacéutico y ciencias de la salud',
        'Gobierno y sector público',
        'Hotelería y turismo',
        'Logística y transporte',
        'Organizaciones sin fines de lucro',
        'Publicidad y marketing',
        'Salud y servicios médicos',
        'SaaS (software como servicio)',
        'Seguros',
        'Servicios legales',
        'Servicios contables',
        'Otro'
      ],
      selectCantidadEmpleados: '',
      cantidadEmpleadosOptions: [
        { value: 'Solo yo', label: 'Solo yo' },
        { value: '1-10', label: '1-10' },
        { value: '11-50', label: '11-50' },
        { value: '51-100', label: '51-100' },
        { value: 'Más de 100', label: 'Más de 100' },
      ],
      selectTipoFirma: '',
      tipoFirmaOptions: [
        { value: 'eFirmaSAT', label: 'Firma con e.firma (SAT)' },
        { value: 'FirmaElectronicaFIREL', label: 'Firma con FIREL (PJF)' },
        { value: 'FirmaBiometricos', label: 'Firma con biométricos (Firma Simple)' },
        { value: 'TodasLasAnteriores', label: 'Quiero todas las anteriores' },
      ],
      selectCantidadFirmas: '',
      cantidadFirmasOptions: [
        { value: '1-10', label: '1-10' },
        { value: '10-50', label: '10-50' },
        { value: '50-100', label: '50-100' },
        { value: '100-1000', label: '100-1,000' },
        { value: 'Mas de 1000', label: 'Más de 1,000' },
      ],
      selectComoSeEntero: '',
      comoSeEnteroOptions: [
        { value: 'Google', label: 'Google' },
        { value: 'Bing', label: 'Bing' },
        { value: 'AnuncioFacebook', label: 'Anuncio en Facebook' },
        { value: 'AnuncioInstagram', label: 'Anuncio en Instagram' },
        { value: 'RecomendacionAmigo', label: 'Recomendación de un amigo' },
        { value: 'Tiktok', label: 'Tiktok' },
        { value: 'Podcast', label: 'Podcast' },
        { value: 'LeiUnBlog', label: 'Leí un blog' },
        { value: 'YouTube', label: 'YouTube' },
        { value: 'Otro', label: 'Otro' },
      ],
      isSubmitting: false,
    };
  },
  methods: {
    getQuestionPending() {
      let values = {
        '¿Cómo usarás Verificamex?': this.selectUsoDigitaFirma,
        '¿Cómo te identificas?': this.selectTipoPersona,
        '¿Cuál es tu sector?': this.selectSector,
        'Tamaño de tu empresa': this.selectCantidadEmpleados,
        '¿Cómo quieres firmar?': this.selectTipoFirma,
        '¿Cuánto firmas al mes?': this.selectCantidadFirmas,
        '¿Cómo se enteró de nosotros?': this.selectComoSeEntero,
      }
      let question = null;
      Object.keys(values).every((key) => {
        if (!values[key]) {
          question = key;
          return false;
        }
        return true;
      });
      return question;
    },
    storeQuestions() {
      if (
        !this.selectUsoDigitaFirma ||
        !this.selectTipoPersona ||
        !this.selectCantidadEmpleados ||
        !this.selectTipoFirma ||
        !this.selectCantidadFirmas ||
        !this.selectComoSeEntero ||
        !this.selectSector
      ) {
        let question = this.getQuestionPending();
        this.$vs.notify({
          title: 'Error',
          text: 'Por favor ingrese los datos requeridos. El campo "' + question + '" es obligatorio.',
          color: 'danger',
          position: 'bottom-center',
        });
        return;
      }
      this.isSubmitting = true;
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#button-with-loading',
        scale: 0.45,
      });
      this.$store
        .dispatch('account/onBoardingQuestions', {
          data: {
            digitafirma_use: this.selectUsoDigitaFirma,
            type_person: this.selectTipoPersona,
            sector: this.selectSector,
            employee_quantity: this.selectCantidadEmpleados,
            type_signature: this.selectTipoFirma,
            signature_quantity: this.selectCantidadFirmas,
            how_to_known: this.selectComoSeEntero,
          },
        })
        .then(
          () => {
            this.$store.dispatch('account/me', { aclChangeRole: this.$acl.change }).then(() => {
              this.isSubmitted = false;
              this.$vs.loading.close('#button-with-loading > .con-vs-loading');
              router.push('/');
            });
          },
          (error) => {
            this.isSubmitting = false;
            this.$vs.loading.close('#button-with-loading > .con-vs-loading');
            console.log(error);
          }
        );
    },

  },
  mounted() {
      const email = this.$store.state.account.user.me.email;
      const phone = this.$store.state.account.user.me.phone;
      window.gtag('set', 'user_data', {
          "email": email,
          "phone_number": `+${phone}`
        });
      window.gtag('event', 'conversion', { send_to: 'AW-462309740/pvl6CMHb3dwZEOySudwB' });

      window.gtag('event', 'sign_up', {
          method: '[GA4]_Registro_exitoso',
          "user_id": email,
          "phone_number": `${phone}`/*No es necesario poner el + ya se envia*/
      });

      window.fbq('track', 'CompleteRegistration', {
          content_name: 'Registro_exitoso_Firma',
          status: 'success',
      });

  },
};
</script>

<style scoped>
body {
  max-height: 100vh;
}
.label-vs {
  font-size: 11.9px !important;
  color: rgba(0, 0, 0, 0.6);
}
.questions-select .vs__dropdown-menu {
  max-height: 300px !important;
}
.select-large .vs__dropdown-toggle {
  padding: 0.59px 0 7px 0 !important;
}
.min-h-login {
  height: 500px;
}
</style>
